import React from "react";
import { Route, Routes } from "react-router-dom";
import TaskList from "./list";
import TaskDetail from "./detail";

export function TasksPage() {
  return (
    <Routes>
      <Route path="/" element={<TaskList />} />
      <Route path="/:id" element={<TaskDetail />} />
    </Routes>
  );
}



